// extracted by mini-css-extract-plugin
export default {"card":"styles_card__IXd76","name":"styles_name__cxD14","cornerButton":"styles_cornerButton__mH7Jz","checkIcon":"styles_checkIcon__4ecPu","locked":"styles_locked__XAmZQ"};